import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import GridContainer from '@r1-frontend/ui-react/components/layouts/gridContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const ACBreakpoints = {
    desktop: '1599px',
    sDesktop: '1375px',
    laptop: '1328px',
    tablet: '1100px',
    mobile: '767px',
    sMobile: '425px',
};

export const FilterContainer = styled(GridContainer)`
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 32px;

    @media (max-width: ${ACBreakpoints.desktop}) {
        justify-content: flex-start;
        width: auto;
        max-width: 1424px;
        padding-left: 16px;
        padding-right: 16px;
    }

    @media (max-width: ${ACBreakpoints.mobile}) {
        position: relative;
    }
`;

export const CardsContainer = styled.div`
    position: relative;
    flex-basis: 1008px;
    margin: 0 -16px;

    @media (max-width: ${ACBreakpoints.sDesktop}) {
        margin: 0 -8px;
    }

    @media (max-width: ${ACBreakpoints.laptop}) {
        margin: 0 -20px;
    }

    @media (max-width: ${ACBreakpoints.tablet}) {
        margin: 0 -8px;
    }

    @media (max-width: ${ACBreakpoints.mobile}) {
        z-index: 3;
    }
`;

export const SelectedFilters = styled.div`
    display: none;

    @media (max-width: ${ACBreakpoints.mobile}) {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 16px 24px;
        margin-bottom: 40px;
        background-color: ${COLORS.BgMain};
    }

    @media (max-width: ${ACBreakpoints.sMobile}) {
        padding-bottom: 8px;
    }
`;

export const FiltersTitle = styled.h4`
    ${FONTS.H4};
    margin-bottom: 8px;
`;

export const FiltersButton = styled(BaseButton)`
    &:not(:last-child) {
        margin-right: 8px;
    }

    @media (max-width: ${ACBreakpoints.sMobile}) {
        margin-bottom: 8px;
    }
`;

export const FiltersBlock = styled.div`
    flex-direction: column;
    margin-bottom: 16px;
`;

export const ControlRow = styled.div``;

export const FixedButton = styled(BaseButton)``;
